export default __webpack_public_path__ + "static/media/bouncing-circles.562d59d8.svg";